import React from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import clsx from 'clsx';
import moment from 'moment';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';

import { getDate, getMonthDate } from 'lib/commonLib';
import DateRangePickerWrapper from './PresetDateRangePicker';
import LabelFilterWrap from 'components/molecules/LabelFilterWrap';

const styles = (theme) => ({
  pickerRoot: {
    cursor: 'auto',
    padding: '0 5px',
    '.en &': { minWidth: '240px' },
    '& input': { cursor: 'pointer' },
    '&.disabled': {
      backgroundColor: 'rgb(234,234,234 ,26%)',
      borderColor: 'rgb(0, 0, 0, 0.26)',
      color: 'rgba(0, 0, 0, 0.38)',
      '& > div': { color: 'rgba(0, 0, 0, 0.38)', backgroundColor: 'initial' },
      '& > .mb-division': { backgroundColor: 'rgb(0, 0, 0, 0.26)' },
    },
  },
});

class DateRangePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
    };
  }

  render() {
    const {
      classes,
      startDateId,
      endDateId,
      handleOnChange,
      locale,
      label,
      filtered,
      initialStartDate,
      initialEndDate,
      useMonthDate,
      customPresets,
      disabled,
      ...rest
    } = this.props;
    const { focusedInput } = this.state;
    const DateRangePic = (
      <DateRangePickerWrapper
        isOutsideRange={(date) => {
          const now = new moment();
          return date.format('YYYYMMDD') > now.format('YYYYMMDD');
        }}
        customArrowIcon={<span>~</span>}
        displayFormat={
          locale === 'ko'
            ? !useMonthDate
              ? 'MMM DD일'
              : 'YY년 MMM'
            : moment.localeData().longDateFormat('L')
        }
        startDateId={startDateId}
        endDateId={endDateId}
        initialStartDate={initialStartDate}
        initialEndDate={initialEndDate}
        focusedInput={focusedInput}
        customPresets={customPresets}
        {...rest}
        onDatesChange={({ startDate, endDate }) => {
          if (startDate !== null && endDate !== null) {
            if (!useMonthDate) {
              handleOnChange({
                startDate: getDate(startDate),
                endDate: getDate(endDate),
              });
            } else {
              handleOnChange({
                startDate: getMonthDate(startDate),
                endDate: getMonthDate(endDate),
              });
            }
          }
        }}
      />
    );

    return (
      <div className="mb-DateRangePicker">
        {!!label ? (
          <LabelFilterWrap
            className={clsx(classes.pickerRoot, !!disabled && 'disabled')}
            label={label}
            filtered
          >
            {!!disabled ? null : DateRangePic}
          </LabelFilterWrap>
        ) : (
           !!disabled ? null : DateRangePic
        )}
      </div>
    );
  }
}

export default connect(
  ({ locale }) => ({
    locale: locale.locale,
  }),
  null
)(withStyles(styles)(DateRangePicker));
